import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
// import { createLogger } from 'redux-logger';
import reducers from '../reducers';
import { jwt } from './middleware';

const middleware = [jwt, thunk];

export default preloadedState =>
  createStore(
    reducers,
    preloadedState,
    compose(
      applyMiddleware(...middleware),
    ),
  );
